import { AddressSearchContainerControllerBase } from '../search/address_search_container_controller_base';

export default class extends AddressSearchContainerControllerBase {
  initialFocusElement() {
    return this.element.querySelector('input[name="search_fields[StreetAddress][value]"]');
  }

  summarizeRow($row) {
    return ($row.find('.controls input[type=text]').first().val() || '').toString().trim();
  }
}
